module.exports = __webpack_public_path__ + "img/1.9cdc5e3f.jpg";